import type { ReactNode } from 'react'
import { cn } from '../lib/utils'

export const PAGE_GUTTER = 'mx-auto w-full max-w-[1400px] px-6'

interface PageContentProps {
	children: ReactNode
	className?: string
}

export function PageContent({ children, className }: PageContentProps) {
	return <div className={cn(PAGE_GUTTER, 'flex flex-col gap-6 pt-6 pb-16', className)}>{children}</div>
}
